import { AccountBalances } from '@/components/layout/accountBalances'
import { routes } from '@/config/routes'
import { useAccountContext } from '@/context/account'
import { useMixpanel } from '@/context/mixpanel'
import { useSettingsContext } from '@/context/settings'
import { getBorrowPositionsTotals, useBorrowPositionsQuery } from '@/queries/borrowPositions.query'
import { usePositionsQuery } from '@/queries/positions.query'
import { NavLink } from 'react-router'
import { ConnectModal } from '../connect/connectModal'
import { ConnectionMenu } from '../connect/connectionMenu'
import { useGroupedBalances } from '../dashboard/useGroupedBalances/useGroupedBalances'
import { useGroupedPositions } from '../dashboard/useGroupedBalances/useGroupedPositions'
import { LogoIcon } from '../icons/logo'
import { SettingsMenu } from '../settings/settingsMenu'
import { MobileMenu } from './mobileMenu'

export const TopBar = () => {
  const { apyRange, includeRewards } = useSettingsContext()
  const { account } = useAccountContext()
  const { trackEvent } = useMixpanel()
  const { data: positionsList } = usePositionsQuery({ address: account, apyInterval: apyRange })
  const { data: borrowPositions, isError: isBorrowPositionsError } = useBorrowPositionsQuery({ address: account })
  const lpTokensBalance = useGroupedPositions(account, positionsList, includeRewards)
  const assetsBalance = useGroupedBalances({ address: account })
  const borrowPositionsTotals =
    borrowPositions === undefined && !isBorrowPositionsError ? undefined : getBorrowPositionsTotals(borrowPositions)

  return (
    <aside className="z-[2] flex h-14 w-full items-center justify-between gap-2 xs:gap-4 border-b bg-page px-4 [grid-area:topBar] md:px-6 xl:gap-5 xl:border-b-none xl:px-8">
      <NavLink to={routes.root} className="mr-auto flex items-center gap-2 text-heading-foreground xl:hidden">
        <LogoIcon />
        <span className="text-xl max-sm:sr-only">vaults.fyi</span>
      </NavLink>
      <nav className="ml-auto flex items-center gap-2 xs:gap-4">
        {account && (
          <AccountBalances
            assetsBalance={assetsBalance}
            lpTokensBalance={lpTokensBalance}
            borrowPositionsTotals={borrowPositionsTotals}
            account={account}
            className="hidden md:flex"
          />
        )}
        {!account && (
          <div className="flex items-center gap-3">
            <ConnectModal
              action="create"
              className="hidden sm:inline-flex"
              onClick={() => trackEvent('Header create wallet button clicked')}
            />
            <ConnectModal action="connect" onClick={() => trackEvent('Header connect wallet button clicked')} />
          </div>
        )}
        {account && <ConnectionMenu account={account} modal={false} className="xxs:flex hidden" />}
        <SettingsMenu modal={false} className="hidden min-w-10 px-1 xl:flex [&>span]:sr-only" />
        <MobileMenu />
      </nav>
    </aside>
  )
}
